import { Api, ApiResponse } from './api';
import { Token } from './token';

export class BulkApi<T> {
    constructor(
        public readonly url: string,
        public readonly resource: string,
        private readonly api: typeof Api,
    ) {}

    /**
     * bulk inserts
     */
    async insert(data: Record<string, unknown>): Promise<ApiResponse|Response> {
        // does not use api.post() because we need the bulk insert endpoint
        const token = await this.api.request_token().then((t: Token) => t.token);

        return fetch(`${this.url}/api/bulk/${this.resource}`, {
            body: JSON.stringify(data),
            method: 'post',
            headers: new Headers({
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            }),
        });
    }

    /**
     * bulk updates
     * @param data - array of updates
     */
    async update(data: Record<string, unknown>): Promise<ApiResponse|Response> {
        // does not use api.put() because we need the bulk update endpoint
        const token = await this.api.request_token().then((t: Token) => t.token);

        return fetch(`${this.url}/api/bulk/${this.resource}`, {
            body: JSON.stringify(data),
            method: 'put',
            headers: new Headers({
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            }),
        });
    }

    /**
     * bulk deletion
     */
    async delete(conditionField: string, conditionId: number): Promise<ApiResponse|Response> {
        // does not use api.delete() because we need the bulk delete endpoint
        const token = await this.api.request_token().then((t: Token) => t.token);

        return fetch(`${this.url}/api/bulk/${this.resource}/${conditionField}/${conditionId}`, {
            method: 'delete',
            headers: new Headers({
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            }),
        });
    }
}
